import { Link } from "react-router";
import { useWindowSize } from "@hooks/useWindowSize";
import Form from "@pages/Newsletter/DecodingAsia/components/Form";
import LeadIntro from "@pages/Newsletter/DecodingAsia/components/LeadIntro";
import ShareLinks from "@pages/Newsletter/DecodingAsia/components/ShareLinks/ShareLinks";

/**
 * The content component for the Decoding Asia newsletter.
 * @figma https://www.figma.com/design/9O7z95a6ncgr3kFoOqJP7Q/BT-GLOBAL?node-id=18438-27713&m=dev
 */
const Content = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <div data-testid="content-component">
      <LeadIntro />

      <Form />

      {isScreenLG ? (
        <div className="border-t border-gray-195 pt-4">
          <ShareLinks />

          <p className="font-poppins text-base font-normal leading-normal text-gray-850">
            Read more about Asia and beyond at The Business Times Global. Visit
            us at{" "}
            <Link
              to="https://bt.global/"
              className="font-medium text-verticals-btblue underline"
              target="_blank"
            >
              bt.global
            </Link>
            .
          </p>
        </div>
      ) : null}
    </div>
  );
};

export default Content;
